export default "__VITE_ASSET__BPRUIkXD__"